import Component from '@glimmer/component';

import type { RadiobuttonItemInfo } from 'webapp/components/form/radiobutton';
import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

interface Args {
	value?: string;
	options?: RadiobuttonItemInfo[];
	onFilterChanged: (value: AnySimpleValue) => void;
	disabled?: boolean;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class SelectableListFilterComponent extends Component<Args> {
	<template>
		<div class="filter-group">

			{{#if @options}}
				<FormRadiobuttonGroupComponent
					class="radiobutton-default"
					@name="permissions"
					@selected={{@value}}
					@options={{@options}}
					@isDisabled={{@disabled}}
					@onChange={{@onFilterChanged}}
				/>
			{{/if}}

		</div>
	</template>
}
